import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/modules/auth/hooks/useAuth';

export function Header({ onSignInNeeded }) {
  const { user } = useAuth();
  const location = useLocation();
  
  // Show the account icon on main pages
  const showAccountIcon = location.pathname === '/' || location.pathname === '/requests';

  return (
    <header className="bg-white/80 backdrop-blur-lg border-b border-white/30 sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-18">
          {/* Enhanced Logo and Title - Now clickable and links to home */}
          <Link 
            to="/" 
            className="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity duration-200"
          >
            <div className="relative">
              <img 
                src="https://supabase.zapt.ai/storage/v1/render/image/public/icons/c7bd5333-787f-461f-ae9b-22acbc0ed4b0/55145115-0624-472f-96b9-d5d88aae355f.png?width=64&height=64" 
                alt="Zaptopia" 
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl shadow-md"
              />
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-blue-500 to-violet-500 rounded-full shadow-sm"></div>
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-black text-slate-800">Zaptopia</h1>
              <p className="text-xs sm:text-sm text-slate-600 hidden sm:block font-medium">Find or create any app</p>
            </div>
          </Link>

          {/* Enhanced Navigation and User Menu */}
          <div className="flex items-center space-x-3 sm:space-x-4">
            {user ? (
              <>
                {showAccountIcon && (
                  <Link
                    to="/account"
                    className="text-slate-600 hover:text-slate-800 cursor-pointer p-2.5 hover:bg-slate-100/80 rounded-xl transition-all duration-200 backdrop-blur-sm border border-transparent hover:border-slate-200"
                    title="Account Settings"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </Link>
                )}
              </>
            ) : (
              <button
                onClick={onSignInNeeded}
                className="text-slate-700 hover:text-slate-900 font-semibold cursor-pointer px-4 py-2 hover:bg-slate-100/80 rounded-xl transition-all duration-200 text-sm backdrop-blur-sm border border-transparent hover:border-slate-200"
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}